<template>
  <div class="boxplot-container">
    <!-- here is the boxplot container
    trackData: {{ k_track_v_boxplotDataKeys }} -->
    <div v-if="trackData">
      <boxplot 
        v-for="(dataKeys, track) in k_track_v_boxplotDataKeys"
        :key="track"
        :track="track" 
        :trackData="trackData"
        :dataKeys="dataKeys"
        :useZScore="useZScore"
        :cohortSelected="cohortSelected"
        :studySelected="studySelected"
      />
    </div>
    <!-- <div v-if="genes && genes.length > 0">
      <boxplot v-for="gene in genes" :key="gene" :tracks="tracks" />
    </div> -->
  </div>
</template>

<script>
import Boxplot from './Boxplot.vue'

export default {
    components: { Boxplot },
    name: "boxplot-container",

    props: ['view', 'studySelected'],

    data: () => ({
    }),
    
    computed: {
        useZScore() { return this.$store.state.Boxplot_useZScore },
        // useZScore() { return this.$store.state.Boxplot_useZScore },
        combinedCohort() { return this.$store.state.Boxplot_combinedCohort },
        boxplotDataType() { return this.$store.state.Boxplot_dataType },
        cohortSelected() { return this.$store.state.Boxplot_cohortSelected },
        k_track_v_boxplotDataKeys() { 
          let res = {}
          // console.log('k_track_v_boxplotDataKeys Boxplot_data', this.$store.state.Boxplot_data)
          // console.log('k_track_v_boxplotDataKeys Boxplot_data_raw', this.$store.state.Boxplot_data_raw)
          // console.log('k_track_v_boxplotDataKeys trackData', this.trackData)

          this.genes.forEach(gene => {
            let geneTracks
            if (this.boxplotDataType === 'All') {
              geneTracks = Object.entries(this.trackData)
                .filter(([, data]) => !data.clinical && data.gene === gene )
                // console.log('k_track_v_boxplotDataKeys geneTracks', geneTracks) 
            } else {
              geneTracks = Object.entries(this.trackData)
                .filter(([, data]) => 
                  !data.clinical && 
                  data.gene === gene && 
                  data.dataType === this.boxplotDataType 
                )
            }
            // console.log('k_track_v_boxplotDataKeys gene', gene)

            // console.log('k_track_v_boxplotDataKeys boxplotDataType', this.boxplotDataType)

            
            geneTracks.forEach(([track, data]) => {
              if (!(data.parent in res)) { res[data.parent] = [] }
              res[data.parent].push(track)
            })
          })
          // console.log('k_track_v_boxplotDataKeys result', res)
          // console.log(res)
          return res
        },
    //     boxplotDataType() { return this.$store.state.boxplotDataType },
    //     boxplotView() { return this.$store.state.boxplotView },
        genes() { return this.$store.state[`${this.view}_genes`] },
        trackDataNormalized() {return this.$store.state.Boxplot_data },
        trackDataRaw() {return this.$store.state.Boxplot_data_raw },
        trackData() { return this.useZScore ?
          this.trackDataNormalized :
          this.trackDataRaw
        },
    //     
    },
    mounted() {
    },
  }
</script>

<style>
.boxplot-container {
    width: 100%;
}
</style>